import React, { useEffect, useState } from 'react';
import './style.modules.css';
import logo from '../../assets/img/Sobr.png';
import couple from '../../assets/ambassadors/couple.png';
import world from '../../assets/ambassadors/world.png';
import asian2 from '../../assets/ambassadors/asian2.png';
import arrow from '../../assets/img/arrow.svg';
import vector5 from '../../assets/ambassadors/Vector5.svg';
import midias from '../../assets/img/Social Media.svg';
import Navbar from '../../components/navbarus';
import vector6 from '../../assets/img/Vector6.png';


function Ambassadors() {


    // Função para rolar até o menu principal
    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo'); // Seleciona o primeiro elemento com a classe 'logo'
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };
        return (
<>
        < Navbar/>
    <header>
        <nav>
            <div className="logo">
                <img src={logo} height="36" width="78" alt="logo" title="logo"/>
            </div>
        </nav>
    </header>
    <body>

                <img className="shade" src={vector5} alt="shade" title="shade"/>
                <img className="couple" src={couple} alt="couple" title="couple" height="450px" width="400px"/>
                <div className='couple-border'></div>
            <main>
                <section className="hero">
                    <div className="content">
                        <h1>Sobr Ambassadors</h1>
                        <p>Our Sobr Ambassadors are the hearts and minds behind the happiness revolution at Sobr. As passionate advocates for sobriety, they embody the values of authenticity, health and genuine connections that make Sobr unique.</p>
                    </div>
                </section>
            </main>
{/*         <div className="form-container">
            <h2 className="form-title">Titulo</h2>
        <form>
            <div className="input-container">
                <input type="text" name="name" placeholder="Name" />
            </div>
            <div className="input-container">
                <input type="email" name="email" placeholder="Email" />
            </div>
            <div className="input-container">
                <input type="text" name="whatsapp" placeholder="Whatsapp" />
            </div>
            <div className="input-container">
                <input type="text" name="instagram" placeholder="Instagram" />
            </div>
        <button type="submit" className="submit-button">Enviar</button>
        </form>
    </div> */}
    <div className="world">
        <img src={world} alt="world" title="world" height="400" width="450"/>
    </div>
    <div className="content2">
        <h1>What our Ambassadors do</h1>
        <p> <strong>Inspire:</strong> Our ambassadors share their personal stories of transformation and growth, inspiring others to embrace sobriety as a positive and fulfilling lifestyle.
<strong>Connect: </strong>They are bridge-builders, uniting people and communities around Sobr's mission to create a happier, healthier world, free from the stigma associated with sobriety.
<strong>Educate:</strong> Our ambassadors are committed educators, providing valuable resources and information about the benefits of sobriety and the support available in the Sobr community.</p>
    </div>
    <img className="asian3" src={asian2} alt="couple" title="couple"/>
    <div className="content3">
        <h1>What our Ambassadors do:</h1>
        <p> <strong>Impact:</strong> Be part of a global community that is changing lives and challenging perceptions about sobriety. As an Ambassador, you will have the opportunity to make a significant difference in other people's lives.
<br></br> <strong>Support:</strong> Receive support from the Sobr team and other ambassadors as you navigate your own sobriety journey and help others on theirs.
<strong>Recognition:</strong> Be recognized as a thought leader and sobriety advocate, featured on our platforms and events, and be part of an exclusive network of global ambassadors.
        </p>
    </div>
{/*     <div className="content7">
        <h1>What our happy customers are saying</h1>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
    <div className="verified">
        <span>Verified by</span>
    </div>
    </div>
    <div className="review-box">
        <div className="header">
            <h3>Margie V.</h3>
            <p>Montevideo</p>
        </div>
    <div className="starx">
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="star">&#9733;</span>
        <span className="time">2 months ago</span>
    </div>
    <div className="content">
        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
    </div>
        <div className="verified">
            <span>Verified by</span>
        </div>
        </div>  
        <div className="review-box">
            <div className="header">
                <h3>Margie V.</h3>
                <p>Montevideo</p>
        </div>
        <div className="starx">
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="star">&#9733;</span>
            <span className="time">2 months ago</span>
        </div>
            <div className="content">
                <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
            </div>
            <div className="verified">
                <span>Verified by</span>
            </div> 
            </div> */}
            <div className="shade2" style={{ backgroundImage: `url(${vector6})` }}>
            </div>
            <div className="midias">           
                <img className="midias" src={midias} height="24" width="260" alt="mídias" title="mídias"/>
            </div>
            <footer>
                <div className="footer-content">
                    <p>Terms de Service | Privacy Policy</p> 
                </div>
                <div className="footer-copyright">
                &copy; 2024 Sobr Inc. All Rights reserved.   
                </div>
                {/* Ícone da seta para rolar até o menu principal */}
                <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                    <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top"/>
                </div>
            </footer>
        </body> 
</>
)
    }
    
export default Ambassadors;